(function(w, d) {
    if (typeof NodeList.prototype.forEach !== "function") { NodeList.prototype.forEach = Array.prototype.forEach; }
    var dycol = {
        init: function () {
            w.dycol_config.forEach(function(o) {
                var ads = [],
                    cards = [],
                    adId = "tnt-smart-ad-",
                    adInterval = o.ad_interval,
                    dropZone = document.getElementById(o.dropzone),
                    trigger = document.getElementById(o.trigger),
                    fetchUrl = __tnt.scrubUrl(o.search_url),
                    startYear = 0,
                    updatedYear = 0,
                    offset = o.offset;
                
                const mapping = {
                          "xs": [[320,50],[300,50],[300,250]],
                          "sm": [[320,50],[300,50],[300,250]],
                          "md": [[468,60],[728,90]],
                          "lg": [[728,90],[468,60],[970,250]]
                      },
                      adSizes = {
                          "minColumnWidth": 300,
                          "slotSize": [[320,50],[300,50],[300,250],[468,60],[728,90],[970,90],[970,250]],
                          "viewportSizes": mapping
                      };
                
                // Set small screen ad interval
                if (window.innerWidth <= 768){
                    adInterval = o.ad_interval_mobile;
                }
                
                // Infinity observer (optional fetch method)
                if (o.fetch_method == "infinity") {
                    // Observer callback
                    var callback = function(entries, io) { 
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting === true) {
                                fetchAssets();
                            }
                        });
                    };
                    
                    // Initialize observer
                    var config = { rootMargin: "0px 0px 500px" },
                        io = new IntersectionObserver(callback, config);
                    io.observe(trigger);
                }
                // Infinity Load more (optional fetch method)
                else if (o.fetch_method== "more") {
                    trigger.addEventListener("click", function(e){
                        spinnerControl();
                        fetchAssets(spinnerControl);
                    });
                }
                
                /** Fetch assets */
                fetchAssets(spinnerControl);
                
                 // Toggle visibility
                function toggle(el) {
                    if (typeof el !== "undefined") {
                        var display = (window.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle).display;
                        if (display == "none") {
                            el.style.display = "";
                        } else {
                            el.style.display = "none";
                        }
                    }
                }
                
                // Spinner display
                function spinnerControl() {
                    var loaderText = document.querySelectorAll(o.trigger_text);
                    if (typeof loaderText !== "undefined") {
                        for (i = 0; i < loaderText.length; ++i) {
                            toggle( loaderText[i] );
                        }
                    }
                }
                
                // Fetch assets
                function fetchAssets(callback) {
                    fetch(fetchUrl)
                        .then(function(response) {
                            if (response.status !== 200) {
                                __tnt.log("Error. Status Code: " + response.status);
                                removeTrigger();
                                return;
                            }
                        // Examine response
                        response.json()
                            .then(function(data) {
                                
                                // Track virtual pageview
                                if (fetchUrl.includes("page=")) {
                                    __tnt.trackEvent( {'url': o.url, 'title': o.title} ); 
                                }
                                
                                // Prepare for next run
                                if (data.next_url !== null) {
                                    fetchUrl = __tnt.scrubUrl(data.next_url);
                                } else {
                                    // End of results
                                    removeTrigger();
                                }
                                // Populate content
                                populateCards(data.assets);
                                
                                // Callback
                                if (typeof callback === "function") {
                                    callback();
                                }
                        });
                    })
                    .catch(function(err) {
                        __tnt.log("Fetch Error: ", err);
                        removeTrigger();
                    });
                }
                
                // Populate drop zone
                function populateCards(assets) {
                    if (assets) {
                        // Create card nodes and insert ads
                        fillTemplate(assets);
                        // Insert cards into document
                        renderCards();
                        // Manage offscreen content
                        pageManagement();
                    } else {
                        __tnt.log("Dynamic collection error: Unexpected JSON response.");
                        removeTrigger();
                    }
                }
                
                // Fill template
                function fillTemplate(assets){
                    const contentWidth = document.getElementById("asset-content").offsetWidth;
                    var adInt = 0;
                    cards = [];
                    
                    /** Push cards and inject ads */
                    assets.forEach(function(asset) {
                        /* Offset assets */
                        if (offset > 0) {
                            offset--;
                            return;
                        }
                        
                        // DFP ad 
                        if (o.advertising && adInt == adInterval && contentWidth >= adSizes.minColumnWidth) {
                            var adsLength = ads.length,
                                adUnitId = adId + adsLength++;
                            
                            // Push ad unit ID to ads array for initalization
                            ads[ads.length] = {"id": adUnitId, "rendered": false};
                            
                            // Create slot
                            try {
                                __tnt.ads.dfp.func.defineSlot(adUnitId, o.ad_slot, adSizes);
                                // Push ad tag to card set
                                cards.push(__tnt.ads.dfp.func.createAdTag(adUnitId));
                            } catch(err) {
                                __tnt.log("Dynamic collection error: " + err.message);
                            }
                            
                            adInt = 0;
                        } else {
                            adInt++;
                        }
                        
                        // Create DOM element for injection
                        var childNode = document.createElement("div");
                        childNode.classList.add(o.asset_class);
                        childNode.innerHTML = asset.content;
                        
                        if (preview()) {
                            childNode = previewScrub(childNode);
                        }
                        
                        // Push completed content div into document
                        cards.push(document.importNode(childNode, true));
                    });
                }
                
                // Render cards
                function renderCards() {
                    var df = d.createDocumentFragment(),
                        page = d.createElement("div"),
                        content = d.createElement("div");
                    
                    page.classList.add("page");
                    content.classList.add("content");
                    
                    // Create empy page and content divs
                    df.appendChild(page);
                    df.querySelector(".page").appendChild(content);
                    
                    // Add cards to page content
                    cards.forEach(function(card) {
                        df.querySelector(".content").appendChild(card);
                    });
                    
                    // Date partition
                    if (o.date_partition === true) {
                        df = dateManagement(df);
                    }
                    
                    // Hide headlines and details
                    if (o.hide_headlines) {
                        df.querySelectorAll(".tnt-headline").forEach(function(headline) {
                            headline.classList.add("hidden");
                        });
                    }
                    if (o.hide_details) {
                        df.querySelectorAll(".tnt-summary").forEach(function(detail) {
                            detail.classList.add("hidden");
                        });
                    }
                    
                    // Append content page to dropzone
                    dropZone.appendChild(df);
                    renderAds();
                }
                
                // Remove trigger
                function removeTrigger() {
                    if (o.fetch_method == "infinity") {
                        io.disconnect();
                    }
                    trigger.parentNode.removeChild(trigger);
                }
                
                // Preview
                function preview() {
                    return window.location.pathname.indexOf("/tncms/admin/action/main/preview/site");
                }
                
                // Preview scrub
                function previewScrub(content) {
                    content.querySelectorAll(".tnt-asset-link").forEach(function(link) {
                        let href = link.getAttribute("href");
                        link.setAttribute("href", __tnt.scrubUrl(href));
                    });
                    return content;
                }
                
                // Render ads
                function renderAds() {
                    if (o.advertising) {
                        for (var i = 0; i < ads.length; i++) {
                            if (!ads[i].rendered) {
                                try {
                                    __tnt.ads.dfp.func.fetchAd(ads[i].id);
                                    ads[i].rendered = true;
                                } catch(err) {
                                    __tnt.log("Dynamic collection error: " + err.message);
                                }
                            }
                        }
                    }
                }
                
                // Date management
                function dateManagement(df) {
                    df.querySelectorAll(".stream-item").forEach(function(item) {
                        /** Display appropriate date information */
                        if (o.sort_rules.startsWith("start_time")) {
                            /* Start partition */
                            if (startYear != item.dataset.startYear || startYear == 0) {
                                startYear = item.dataset.startYear;
                                var partition = document.createElement("h3");
                                partition.classList.add("date-partition", "start");
                                partition.append(startYear);
                                item.parentNode.insertBefore(partition, item)
                            }
                            
                            // Show start date on cards
                            df.querySelectorAll(".stream-item-bullet .start-date").forEach(function(bullet) {
                                bullet.classList.remove("hidden");
                            });
                        } else {
                            /* Updated partition */
                            if (item.dataset.updatedYear && updatedYear != item.dataset.updatedYear || updatedYear == 0) {
                                updatedYear = item.dataset.updatedYear;
                                var partition = document.createElement("h3");
                                partition.classList.add("date-partition", "updated");
                                partition.append(updatedYear);
                                item.parentNode.insertBefore(partition, item);
                            }
                            
                            // Show updated date on cards
                            df.querySelectorAll(".stream-item-bullet .updated-date").forEach(function(bullet) {
                                bullet.classList.remove("hidden");
                            });
                        }
                    });
                    return df;
                }
                
                // Page management
                function pageManagement() {
                    if (o.page_man === false) return;
                    var returnCallback = function(entries, returnio) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting === true) {
                                // Returning to viewport
                                entry.target.firstElementChild.classList.remove("hidden");
                            } else {
                                // Out of viewport
                                entry.target.firstElementChild.classList.add("hidden");
                            }
                        });
                    };
                    
                    var arrival = dropZone.lastElementChild, // added to the bottom of viewport
                        active = arrival.previousElementSibling; // on the edge of the viewport
                    
                    if (active) {
                        var prev = active.previousElementSibling; // out of viewport to be hidden/removed
                        if (prev) {
                            var height = __tnt.outerHeight(prev, true);
                            prev.style.height = (height + "px");
                            prev.firstElementChild.classList.add("hidden");
                            prev.classList.add("return-trigger");
                            // Observe removed page for later interaction
                            var config = {
                                rootMargin: "100px 0px 100px"
                            };
                            var returnio = new IntersectionObserver(returnCallback, config);
                            returnio.observe(prev);
                        }
                    }
                }
                
            });
        }
    };
    if (d.readyState == "loading") {
        d.onreadystatechange = function () {
            if (d.readyState == "complete") {
                dycol.init();
            }
        }
    } else {
        dycol.init();
    }
})(window, document);